const Container = ({ children, ...props }) => {
  return (
    <main className="content" {...props}>
      {children}
    </main>
  );
};

export default Container;
